import styled from '@emotion/styled';

import { BasicFlex } from '../Common';

const RowLine = styled(BasicFlex)`
  gap: ${props => props.$gap || "1rem"};
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

const HeaderRowLine = styled(RowLine)`
  text-transform: uppercase;
  font-weight: 500;
`;

const RowField = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  /* text-align: center; */
  border-right: ${props => props.$borderless ? "none" : `1px solid ${props.theme.colors.border}`};
  padding: 1rem;
  height: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: ${props => props.$justify || "center"};
`

const BasicRowField = styled(RowField)`
  border-right: none;
  height: auto;
`;

const CheckField = styled(RowField)`
  max-width: 5rem;
`

const ActionField = styled(RowField)`
  max-width: 10rem;
  border-right: none;
`;

const AmountField = styled(RowField)`
  max-width: 15rem;
  border-right: none;
`;

export { RowLine, HeaderRowLine, RowField, CheckField, AmountField, ActionField, BasicRowField };